<template>
    <div>
        <el-checkbox-group v-show="!init_error" v-model="context" @change="handle_selection_change">
            <el-checkbox 
                v-for="(option, idx) in options" 
                :label="option.value"
                :key="idx"
            >
                {{option.label}}
            </el-checkbox>
            <el-tag
                :key="tag"
                v-for="tag in others"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)"
            >
                {{tag}}
            </el-tag>
            <el-input
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">新增其它</el-button>
        </el-checkbox-group>
        
    </div>
</template>

<script>

export default {
    props: ['value', 'options'],
    data() {
        return {
            init_error: false,
            form_valid: true,
            others: [],
            context: [],
            inputVisible: false,
            inputValue: ''
        }
    },
    watch: {
        value () {
            this.init()
        },
        options () {
            this.init()
        }
    },
    created: function () {
        this.init()
    },
    methods: {
        init () {
            console.log('SelectWithOptionOthers: init: value=', this.value)
            if (!this.options) {
                console.warn('SelectWithOptionOthers: invalid options')
                this.init_error = true
                return
            }

            this.context = []
            this.others = []

            let possible_values = this.options.map(x => x.value)
            if (this.value && Array.isArray(this.value)) {
                for (let item of this.value) {
                    if (possible_values.indexOf(item) !== -1) {
                        this.context.push(item)
                    }
                    else {
                        this.others.push(item)
                    }
                }
            }
        },
        handle_selection_change () {
            this.$emit('change', this.context.concat(this.others))
        },
        handleClose(tag) {
            this.others.splice(this.others.indexOf(tag), 1);
            this.handle_selection_change()
        },

        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.others.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
            this.handle_selection_change()
        }
    }
};
</script>


<style lang="scss" scoped>
/deep/.el-form-item__label {
background-color: rgba(25, 111, 61, 0.1);
padding: 0 5px;
}
/deep/.el-form-item__content {
   padding: 0 5px;
}
/deep/.el-tag:first-of-type {
    margin-left: 20px;
}
/deep/.el-tag + .el-tag {
    margin-left: 10px;
}

.action_buttons {
  float: right;
  .el-button {
    margin-right: 22px;
  }
}

.choices-checkbox{
  margin-bottom: 22px;
}

.clearfix::after {
    content: "";
    clear: both;
    display: table;
}

.field {
  padding: 5px;
  background-color: rgba(25, 111, 61, 0.1);
  width: 200px;
  vertical-align: top;
  &+.value {
    vertical-align: top;
    padding: 5px;
  }
}

.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}

</style>
